export function saveFile(filename: string, content: string, type: string) {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function saveSvg(filename: string, id: string, type: string) {
  const element = document.getElementById(id)
  saveFile(filename, `${element?.outerHTML}`, type)
}
